import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "layout" }
const _hoisted_2 = { class: "grid grid-cols-3 gap-0 justify-items-stretch" }
const _hoisted_3 = { class: "mr-3" }
const _hoisted_4 = { class: "flex justify-center items-center border border-white rounded hover:border-gray-200 text-blue-500 hover:bg-gray-200 py-2 px-4" }
const _hoisted_5 = {
  key: 0,
  class: "m-0"
}
const _hoisted_6 = { class: "flex justify-center items-center border border-white rounded hover:border-gray-200 text-blue-500 hover:bg-gray-200 py-2 px-4" }
const _hoisted_7 = { class: "m-0" }
const _hoisted_8 = { class: "m-0" }
const _hoisted_9 = { class: "flex justify-center items-center border border-white rounded hover:border-gray-200 text-blue-500 hover:bg-gray-200 py-2 px-4" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "material-icons mr-2" }, "person", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NounsUser = _resolveComponent("NounsUser")!
  const _component_PhotoView = _resolveComponent("PhotoView")!
  const _component_PhotoNFTRequest = _resolveComponent("PhotoNFTRequest")!
  const _component_GuideLogin = _resolveComponent("GuideLogin")!
  const _component_GuidePhoto = _resolveComponent("GuidePhoto")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_photo_select = _resolveComponent("photo-select")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Languages = _resolveComponent("Languages")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_NounsUser),
    _createVNode(_component_PhotoView),
    _createVNode(_component_PhotoNFTRequest),
    _createVNode(_component_GuideLogin, { ref: "guideLogin" }, null, 512),
    _createVNode(_component_GuidePhoto, {
      ref: "guidePhoto",
      photoSelect: _ctx.photoSelect
    }, null, 8, ["photoSelect"]),
    _createElementVNode("ul", _hoisted_2, [
      _createElementVNode("li", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: _ctx.localizedUrl('/map')
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("menu.map")), 1)
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      (_ctx.featureConfig.enableNFTReq)
        ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: _ctx.localizedUrl('/nft')
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("menu.nft")), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("li", _hoisted_7, [
        _createElementVNode("a", {
          class: "flex justify-center items-center border border-white rounded hover:border-gray-200 text-blue-500 hover:bg-gray-200 py-2 px-4",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showUpload && _ctx.showUpload(...args))),
          id: "UploadMenu"
        }, _toDisplayString(_ctx.$t("menu.upload")), 1)
      ]),
      _createElementVNode("li", _hoisted_8, [
        _createVNode(_component_router_link, {
          to: _ctx.localizedUrl(`/user`)
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("menu.user")), 1)
            ])
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ]),
    _createVNode(_component_photo_select, { ref: "photoSelect" }, null, 512),
    _createVNode(_component_router_view),
    _createVNode(_component_Languages, { class: "mt-4" })
  ]))
}